"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    insectPhenology_1: _aggregation_helpers_1.unaggregatedOnlyAggregationIntervalHelper,
    insectPhenology_7: _aggregation_helpers_1.unaggregatedOnlyAggregationIntervalHelper,
    insectPhenology_11: _aggregation_helpers_1.unaggregatedOnlyAggregationIntervalHelper,
};
//# sourceMappingURL=phenology_insect.js.map